<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Move'"
    :max-width="700"
  >
    <template slot="header">
      <div
        style="width: 100%;"
        class="d-flex justify-space-between align-center pa-3"
      >
        <span
          v-if="item"
          class="f6 fw600"
        >Tag# - {{ item.tag_id }}</span>
        <div
          class="d-flex"
          style="gap: 6px;"
        >
          <v-chip
            :color="item && item.status ? item.status.color : 'black'"
            text-color="white"
          >
            {{ item && item.status ? item.status.name : '' }}
          </v-chip>
        </div>
      </div>
    </template>
    <template slot="body">
      <div
        v-if="item"
        class="d-flex flex-column ga-6 pa-3 pt-0"
      >
        <div class="d-flex flex-column ga-1">
          <span class="title-span">Job</span>
          <div class="desc-div">
            <span
              class="desc-span"
              style="font-weight: bold;"
            >{{ item.job_code ? `${item.job_code}` : '' }}</span> - <span class="desc-span">{{ item.job_name ? item.job_name : item.job_name }}</span> <span
              class="desc-span"
              style="color: #1976D2;"
            >{{ item.job_reference ? `; ${item.job_reference}` : '' }}</span>
          </div>
        </div>

        <div class="d-flex flex-column ga-1">
          <span class="title-span">Type</span>
          <div class="desc-div">
            <span
              class="desc-span"
            >{{item && item.type ? item.type.name : ''}}</span>
          </div>
        </div>

        <div class="d-flex ga-3 align-center" v-if="isFrame">
          <div class="outer-div">
            <span class="title-span">Aluminum Die</span>
            <div class="desc-div">
              <span
                class="desc-span"
              >{{item.aluminum_die.code}}</span>
            </div>
          </div>

          <div class="outer-div">
            <span class="title-span">Length</span>
            <div class="desc-div">
              <span
                class="desc-span"
              >{{ item.width ? item.width + '"' : item.height ? item.height + '"' : '-' }}</span>
            </div>
          </div>
        </div>

        <div class="d-flex ga-3 align-center" v-if="!isFrame">
          <div class="outer-div">
            <span class="title-span">Width</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.width ? item.width + '"' : '-' }}</span>
            </div>
          </div>

          <div class="outer-div">
            <span class="title-span">Height</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.height ? item.height + '"' : '-' }}</span>
            </div>
          </div>
        </div>

        <div
          v-if="item.status_id == finishedGoodCommercialStatusIdQuarantined"
          class="d-flex flex-column ga-1"
        >
          <span class="title-span">Quarantine Reasons</span>
          <div class="desc-div">
            <span
              class="desc-span"
            >{{ item.quarantine_reason ? item.quarantine_reason.name : '' }} - {{ item.quarantine_sub_reason ? item.quarantine_sub_reason.name : '' }}; {{ item.quarantined_at ? item.quarantined_at : '' }}</span>
          </div>
        </div>

        <v-divider style="border-bottom: 1px solid #BDBDBD;" />

        <span
          class="f8 fw600"
          style="color: #000"
        >Status Managemenet </span>

        <div class="outer-div">
          <span class="title-span">Move to Status</span>
          <v-select
            v-model="selectedStatusId"
            :items="statuses"
            item-text="name"
            item-value="id"
            hide-details="true"
            outlined
            clearable
            :rules="[(v) => !!v || 'Move to Status is required']"
            placeholder="Select Status"
          >
            <template #item="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #selection="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
          </v-select>
        </div>
        <div
          v-if="selectedStatusId === finishedGoodCommercialStatusIdFinishedGood"
          class="d-flex ga-3 align-center"
        >
          <v-autocomplete
            v-model="locationId"
            :items="locations"
            item-text="name"
            item-value="id"
            outlined
            :disabled="true"
          >
            <template slot="label">
              Location<RedAsterisk />
            </template>
          </v-autocomplete>
          <!-- <v-autocomplete
            v-model="inventoryLocationId"
            :items="inventoryLocations"
            item-text="name"
            item-value="id"
            outlined
            placeholder="Select shelf"
            :rules="[(v) => !!v || 'Shelf is required']"
          >
            <template slot="label">
              Shelf<RedAsterisk />
            </template>
          </v-autocomplete> -->
        </div>

        <div
          v-if="selectedStatusId === finishedGoodCommercialStatusIdQuarantined"
          class="d-flex ga-3 align-center"
        >
          <v-select
            v-model="quarantineReasonId"
            :items="quarantineReasons"
            label="Main Category"
            item-text="name"
            item-value="id"
            outlined
            :rules="[(v) => !!v || 'Main Category is required']"
          >
            <template slot="label">
              Main Category<RedAsterisk />
            </template>
          </v-select>
          <v-select
            v-model="quarantineSubReasonId"
            :items="quarantineSubReasons"
            label="Sub Category"
            item-text="name"
            item-value="id"
            outlined
            :rules="[(v) => !!v || 'Sub Category is required']"
            :disabled="!quarantineReasonId"
          >
            <template slot="label">
              Sub Category<RedAsterisk />
            </template>
          </v-select>
        </div>

        <!-- <div>
          <v-btn
            color="orange"
            outlined
            small
            @click="runWebhook(item)"
          >
            WINDOW QR CODE LABEL
          </v-btn>
        </div> -->
        <confirm-form ref="confirmForm" />
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as FormatHelpers from '@/helpers/FormatHelpers';
import { saveAs } from 'file-saver';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    finishedGoodCommercialStatusIdFinishedGood: 8,
    finishedGoodCommercialStatusIdQuarantined: 13,

    finishedGoodCommercialTypeIdWindow: 1,
    finishedGoodCommercialTypeIdDoor: 2,
    finishedGoodCommercialTypeIdFrame: 3,
    finishedGoodCommercialTypeIdSlab: 4,
    productionScheduleStatusIdInProgress: 1,

    selectedStatusId: null,
    locationId: null,
    // inventoryLocationId: null,
    quarantineReasonId: null,
    quarantineSubReasonId: null,
    statuses: [],
    inventoryLocations: [],
    locations: [],
    quarantineReasons: [],
    quarantineSubReasonsAll: [],
    quarantineSubReasons: [],

  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
    isDoor() {
      return this.item && this.item.type_id === this.finishedGoodCommercialTypeIdDoor;
    },
    isWindow() {
      return this.item && this.item.type_id === this.finishedGoodCommercialTypeIdWindow;
    },
    isFrame() {
      return this.item && (this.item.type_id === this.finishedGoodCommercialTypeIdFrame || this.item.type_id === this.finishedGoodCommercialTypeIdSlab);
    },
  },
  watch: {
    quarantineReasonId() {
      this.quarantineSubReasons = this.quarantineSubReasonsAll.filter((x) => x.reason_id === this.quarantineReasonId);
    },
  },
  created() {
    this.getQuarantineReasons();
    this.getQuarantineSubReasons();
  },
  methods: {

    async get(qrCode) {
      this.$bus.$emit('loading');
      const submitModel = {
        filters: {
          tag_id: qrCode,
          is_job: 1,
        },
      };
      const res = await this.$api.finishedGoodCommercial.read(submitModel);

      if (!res || res.length === 0) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Finished Good not found');
        this.$refs.dialogBox.close();
        return;
      }
      const firstIndex = 0;
      this.item = res[firstIndex];
      if (this.item.commercial_schedule && this.item.commercial_schedule.status_id !== this.productionScheduleStatusIdInProgress) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Finished Good\'s Curtainwall Schedule status is not set to In Progress (Current)');
        this.$refs.dialogBox.close();
        return;
      }
      if (this.item && (this.item.type_id === this.finishedGoodCommercialTypeIdWindow || this.item.type_id === this.finishedGoodCommercialTypeIdDoor)) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Windows and Doors cannot be moved, please scan a frame or slab component tag');
        this.$refs.dialogBox.close();
        return;
      }
      await this.getStatuses();
      this.getCommercialSchedule(this.item.commercial_schedule_id);
      this.$bus.$emit('loading');
    },

    async getStatuses() {
      const submitModel = {
        filters: {
          is_stage: 1,
          is_commercial_schedule_qr: 1,
        },
        sort: {
            order_by_first: 'stage_order',
            direction_sort: false,
        },
      };
      if (this.item && this.item.job && this.item.job.sub_class_id) {
        submitModel.filters.job_sub_class_id = this.item.job.sub_class_id;
      }
      const res = await this.$api.finishedGoodCommercialStatus.read(submitModel);
      this.statuses = res;
    },

    async getQuarantineReasons() {
      this.quarantineReasons = await this.$api.finishedGoodQuarantineReason.get();
    },

    async getQuarantineSubReasons() {
      this.quarantineSubReasonsAll = await this.$api.finishedGoodQuarantineSubReason.get();
    },

    async submit() {
      if (this.item.status_id === this.finishedGoodCommercialStatusIdQuarantined) {
        let item = this.item.type ? this.item.type.name : 'finished good commercial item';
        const confirm = await this.$refs.confirmForm.open({
          title: `Was the ${item} fixed?`,
        });
        if (!confirm) {
          this.$bus.$emit('showError', `Please fix the ${item} before moving to another status`);
          return false;
        }
      }

      const submitModel = {
        tag_id: this.item.tag_id,
        status_id: this.selectedStatusId,
        location_id: this.locationId,
        // inventory_location_id: this.inventoryLocationId,
        quarantine_reason_id: this.quarantineReasonId,
        quarantine_sub_reason_id: this.quarantineSubReasonId,
        job: this.item.job ? {
          id: this.item.job.id,
          code: this.item.job.code,
          name: this.item.job.name,
          reference: this.item.job.reference,
          sub_class_id: this.item.job.sub_class_id,
        } : null,
      };
      const res = await this.$api.finishedGoodCommercial.store(submitModel, 'change-status');

      const httpStatusCodeConflict = 409;
      const httpStatusCodeNotExtended = 510;
      if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended) {
        this.$bus.$emit('showError', res.message);
        return false;
      }

      if (!res) {
        this.$bus.$emit('showError', res);
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    async getLocations() {
      this.locations = await this.$api.location.getList();
    },

    async getInventoryLocations() {
      const readModel = {
        filters: {
          finished_good_status_id: this.finishedGoodCommercialStatusIdFinishedGood,
          location_id: this.locationId,
        },
      };
      this.inventoryLocations = await this.$api.inventoryLocation.read(readModel);
    },

    async getCommercialSchedule(commercialScheduleId) {
      const submitModel = {
        filters: {
          id: commercialScheduleId,
        },
      };
      const res = await this.$api.commercialSchedule.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.allItems = [];
        this.totalItems = 0;
      }
      this.locationId = res.data[0].location_id;
      this.getInventoryLocations();
    },

    open(qrCode) {
      if (!qrCode) return;
      this.resetForm();
      this.get(qrCode);
      this.getLocations();
      this.$refs.dialogBox.open();
    },

    resetForm() {
      this.item = null;
      this.selectedStatusId = null;
      this.locationId = null;
      this.quarantineReasonId = null;
      this.quarantineSubReasonId = null;
      this.statuses = [];
      this.quarantineSubReasons = [];
    },

    // async runWebhook(item) {
    //   this.$bus.$emit('loading');

    //   const webhookModuleIdWindowLabels = 52;
    //   const webhookData = {
    //     module_id: webhookModuleIdWindowLabels,
    //     tag_id: item.tag_id,
    //   };

    //   const res = await this.$api.webhook.store(webhookData, 'run-download', { responseType: 'blob' });
    //   if (!res) {
    //     this.$bus.$emit('showError');
    //     this.$bus.$emit('loading');
    //     return;
    //   }

    //   const now = FormatHelpers.getFileTimestamp();
    //   const label = item.tag_id.replace(/[\s.]/g, '-');
    //   const fileName = `${label}_Window_Label_${now}`;

    //   const file = new Blob([res], {
    //     type: 'application/pdf',
    //   });
    //   saveAs(file, fileName);
    //   this.$bus.$emit('loading');
    // },
  },
};
</script>

<style scoped>
.outer-div{
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

}
.title-span
{
  color: #000;
  font-size: 18px;
  font-weight: 500;
}

.desc-div
{
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 8px;
  padding-right: 8px;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  background-color: #F9F9FA;
}

.desc-span
{
  color: #000;
  font-size: 20px;
}
</style>
